import script from "./AccountButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./AccountButton.vue?vue&type=script&lang=ts&setup=true"

import "./AccountButton.vue?vue&type=style&index=0&id=1ece10ee&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ece10ee"]])

export default __exports__